/* Phone menu: shows that a category panel scrolls.
   Adds .ol-has-more to a panel while there is more list below, and gives one small nudge
   (list moves down a little, then back) the first time a panel that scrolls is opened in a visit. */
(function(){
  if(!window.IntersectionObserver)return;
  var KEY='olNavCueSeen';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seen=false;
  try{seen=sessionStorage.getItem(KEY)==='1';}catch(e){}
  function mark(){seen=true;try{sessionStorage.setItem(KEY,'1');}catch(e){}}
  function pane(sc){return sc.closest('.olnav-m-pane');}
  function update(sc){
    var p=pane(sc); if(!p)return;
    var more=sc.scrollHeight-sc.clientHeight>12 && sc.scrollTop+sc.clientHeight<sc.scrollHeight-8;
    p.classList.toggle('ol-has-more',more);
  }
  function nudge(sc){
    if(seen||reduce)return;
    if(sc.scrollHeight-sc.clientHeight<60||sc.scrollTop>0)return;
    mark();
    var touched=false;
    function stop(){touched=true;}
    sc.addEventListener('touchstart',stop,{once:true,passive:true});
    setTimeout(function(){
      if(touched||sc.scrollTop>0)return;
      try{sc.scrollTo({top:44,behavior:'smooth'});}catch(e){sc.scrollTop=44;}
      setTimeout(function(){
        if(touched)return;
        try{sc.scrollTo({top:0,behavior:'smooth'});}catch(e){sc.scrollTop=0;}
      },520);
    },500);
  }
  function wire(sc){
    if(sc.__olCue)return; sc.__olCue=true;
    sc.addEventListener('scroll',function(){update(sc);},{passive:true});
    if(window.ResizeObserver){var ro=new ResizeObserver(function(){update(sc);}); ro.observe(sc); if(sc.firstElementChild)ro.observe(sc.firstElementChild);}
    io.observe(sc);
  }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting&&e.intersectionRatio>=0.6){update(e.target);nudge(e.target);}
    });
  },{threshold:[0,0.6,1]});
  function init(){
    Array.prototype.forEach.call(document.querySelectorAll('#jbf-mobile-drawer .olnav-m-scroll'),wire);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
